/* TODO: t() */
import React, { ComponentProps } from 'react';

import TextInput from './TextInput';

type Props = Omit<
  ComponentProps<typeof TextInput>,
  'onChangeText' | 'value'
> & {
  style?: StyleSet;
  // TODO: Remove this, it's not being used.
  containerStyle?: StyleSet;
  onChangeText: (text: string) => void;
  value: string;
};

export default function TextInputSearch(props: Props) {
  let { containerStyle, onChangeText, value, ...otherProps } = props;

  return (
    <TextInput
      placeholder="Search"
      value={value}
      onChangeText={(t) => onChangeText(t)}
      {...otherProps}
    />
  );
}
